var viewer_rtlignore_default = {
  "gallery_container": "_0EKRd",
  "imageTitleContainer": "hH2BO",
  "clickableItem": "ZdDDJ",
  "prerender": "pXS6Y",
  "expandButton": "Laxy7",
  "itemContainer": "noOLR",
  "expandIcon": "_0-RH2",
  "itemOverlay": "h-x5W",
  "imageTitle": "zdWg9",
  "pointer": "w3fA6",
  "fadeIn": "_5Ll7f",
  "changing_background": "gI-tX"
};
export {
  viewer_rtlignore_default as default
};
//# sourceMappingURL=viewer.rtlignore-scss.js.map
